import { ColorFormatConverter } from '../../../shared/utilities/color_format_converter';
import { Cesium } from '../../../cesium';
import { ViewStateService } from '../../../shared/view_state.service';

export class AssetNextHopTreeViewFactoryHelper {
    _viewStateService: ViewStateService;

    constructor(viewStateService: ViewStateService) {
        this._viewStateService = viewStateService;
    }

    getColorForNode(node, time) {
        let currentView = this._viewStateService.currentViewController;
        let cesiumColor;
        if (currentView.currentAssetVisualiser) {
            cesiumColor = currentView.currentAssetVisualiser.entityVisualiser.getAssetColor(
                node.cesiumEntity.imsAsset,
                time,
            );
        } else {
            cesiumColor = ColorFormatConverter.convertCesiumColorToHexColor(Cesium.Color.WHITE);
        }
        return ColorFormatConverter.convertCesiumColorToHexColor(cesiumColor);
    }
}
